interface FencingQuestionsProps {
    fencingQuestions: NewJobQuoteFenceQuestions;
    braces: number;     //recommended number of braces to add
    errors: { [key: string]: string };
    updateTotalMetres(totalMetres: number): void;
    updateFencingQuestion(questionName: string, questionValue: boolean): void;
    updateSignagePanels(panels: number): void;
    updateFenceArea(checked: boolean, itemIndex: number): void;
}

interface NewJobQuoteFenceQuestions {
    fenceTotalMetres: number;
    treeProtection: boolean;
    highWindArea: boolean;
    shadeClothAdded: boolean;
    signageAdded: boolean;
    signagePanels: number;
    fenceAreas: FenceAreaOption[];
}

interface FenceAreaOption {
    id: number;
    name: string;
    selected: boolean;
}

const JobScheduleAddFenceQuestionsData = (props: FencingQuestionsProps) => {

    const isFullBoundry = props.fencingQuestions.fenceAreas.find(f => f.id === 1)?.selected;

    return (
        <div>
            <label className="input-group marginBottom10" htmlFor="fenceTotalMetres">
                <span className="label label-large">Total Fence Metres</span>
                <input className="input textalignright" min={0} step={1} type="number" id="fenceTotalMetres" name="fenceTotalMetres" value={props.fencingQuestions.fenceTotalMetres} onChange={(e) => props.updateTotalMetres(Number(e.target.value))}></input>
            </label>
            <span className={props.errors["fenceTotalMetres"] ? "label errors marginLeftLabelLarge" : "hidden"}>{props.errors["fenceTotalMetres"]}</span>

            <label className="input-group" htmlFor="treeProtection">
                <span className="label label-large">Is tree protection required?</span>
                <input className="checkbox" type="checkbox" name="treeProtection" checked={props.fencingQuestions.treeProtection} onChange={(e) => props.updateFencingQuestion(e.target.name, e.target.checked)} ></input>
            </label>
            <span className={props.fencingQuestions.treeProtection ? "makeitorange" : "hidden"}>Confirm that an extra lm per tree has been included in Total Fence Metres.</span>

            <label className="input-group" htmlFor="highWindArea">
                <span className="label label-large">Is the site in a high wind area?</span>
                <input className="checkbox" type="checkbox" name="highWindArea" checked={props.fencingQuestions.highWindArea} onChange={(e) => props.updateFencingQuestion(e.target.name, e.target.checked)} ></input>
            </label>

            <label className="input-group" htmlFor="shadeClothAdded">
                <span className="label label-large">Will shade cloth (ours or theirs) be used?</span>
                <input className="checkbox" type="checkbox" name="shadeClothAdded" checked={props.fencingQuestions.shadeClothAdded} onChange={(e) => props.updateFencingQuestion(e.target.name, e.target.checked)} ></input>
            </label>

            <label className="input-group" htmlFor="signageAdded">
                <span className="label label-large">Will signs be added to any fence panels?</span>
                <input className="checkbox" type="checkbox" name="signageAdded" checked={props.fencingQuestions.signageAdded} onChange={(e) => props.updateFencingQuestion(e.target.name, e.target.checked)} ></input>
            </label>

            <div className={props.fencingQuestions.signageAdded ? "" : "hidden"}>
                <label className="input-group" htmlFor="signagePanels">
                    <span className="label label-large">Enter # Panels Signs will added to</span>
                    <input className="input customer__invDays" type="number" min="0" step="1" id="signagePanels" name="signagePanels" value={props.fencingQuestions.signagePanels} onChange={(e) => props.updateSignagePanels(Number(e.target.value))}></input>
                </label>
                <span className={props.errors["signagePanels"] ? "label errors marginLeftLabelLarge" : "hidden"}>{props.errors["signagePanels"]}</span>
            </div>

            <div className={(props.fencingQuestions.highWindArea || props.fencingQuestions.shadeClothAdded) ? "makeitorange makeitbold marginLeftLabelLarge marginBottom10" : "hidden"}>
                Bracing recommended for every {props.fencingQuestions.highWindArea && props.fencingQuestions.shadeClothAdded ? "panel"
                    : !props.fencingQuestions.highWindArea && props.fencingQuestions.shadeClothAdded ? "2nd panel"
                        : props.fencingQuestions.highWindArea && !props.fencingQuestions.shadeClothAdded ? "3rd panel" : ""}
                {props.fencingQuestions.highWindArea && props.fencingQuestions.shadeClothAdded ? "" : props.fencingQuestions.signageAdded ? " and to the " + (props.fencingQuestions.signagePanels > 0 ? props.fencingQuestions.signagePanels : "") + " panels with signs added" : ""}
            </div>
            <div className={!props.fencingQuestions.highWindArea && !props.fencingQuestions.shadeClothAdded && props.fencingQuestions.signageAdded ? "makeitorange makeitbold marginLeftLabelLarge marginBottom10" : "hidden"}>
                Bracing recommended for the {props.fencingQuestions.signagePanels > 0 ? props.fencingQuestions.signagePanels : ""} panels with Signs added.
            </div>

            <div className={props.braces > 0 ? "" : "hidden"}>Recommend adding {props.braces} braces. Click Save to add braces.</div>

            <label className="input-group" htmlFor="fenceArea">
                <span className="label label-large">Select Fence Area/s</span>
                <div>
                    {props.fencingQuestions.fenceAreas.map((item, index) =>
                        <span key={item.id} className="newJobFenceAreaContainer marginLeftLabelLarge">
                            <input className="checkbox" type="checkbox" id={"fenceArea" + index} name={"fenceArea" + index} checked={item.selected} onChange={(e) => props.updateFenceArea(e.target.checked, index)} disabled={isFullBoundry && item.id > 1}></input>
                            <label className="label marginLeft20" htmlFor={"fenceArea" + index}>{item.name}</label>
                        </span>
                    )}
                </div>
            </label>
            <span className={props.errors["fenceArea"] ? "label errors marginLeftLabelLarge" : "hidden"}>{props.errors["fenceArea"]}</span>

        </div>
    )
}

export default JobScheduleAddFenceQuestionsData;